import React, { useContext } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { UI } from "@wwimmo/ui";
import { Role } from "src/network/User";
import { EasyContactCommunicationSettings } from "src/screens/communicationSettings/easycontactTicketing/easycontact/EasyContactCommunicationSettings";
import { TicketingCommunicationSettings } from "src/screens/communicationSettings/easycontactTicketing/ticketing/TicketingCommunicationSettings";
import styles from "src/screens/communicationSettings/CommunicationSettings.module.css";

const EasyContactTicketingCommunicationSettingsBase = (props: RouteComponentProps) => {
    const { t } = useTranslation();
    const { navStore, communicationSettingsStore, authStore } = useContext(RootStoreContext);

    const isAdministrator = authStore.user?.availableRoles?.includes(Role.ADMINISTRATOR) ?? false;
    const isEcAdmin = authStore.user?.availableRoles?.includes(Role.ECADMIN) ?? false;

    const showEasyContact = (isEcAdmin || isAdministrator) && navStore.hasFeatureEasyContact;
    const showTicketing = isAdministrator && navStore.hasFeatureTicketing;

    const onSave = async () => {
        await communicationSettingsStore.saveEasyContactTicketingSettings();
    };

    const onDiscard = () => {
        communicationSettingsStore.resetEasyContactTicketingSettings();
    };

    const saveSettingsButtonLabel = (
        <div className="d-flex align-items-center">
            <div>{t("labels.save")}</div>
            <UI.RotatingSpinner
                className={`${styles.SaveButtonSpinner} ${
                    communicationSettingsStore.isLoadingEasyContactTicketingSettings ? "" : "d-none"
                }`}
                noLogo={true}
                size={20}
            />
        </div>
    );

    return (
        <React.Fragment>
            {showEasyContact && <EasyContactCommunicationSettings />}
            {showTicketing && <TicketingCommunicationSettings />}
            <UI.Row>
                <UI.Col xl={9}></UI.Col>
                <UI.Col xl={3} className="d-flex justify-content-end align-items-center">
                    <UI.Button
                        onClick={onSave}
                        label={saveSettingsButtonLabel}
                        disabled={
                            communicationSettingsStore.isLoadingEasyContactTicketingSettings ||
                            !communicationSettingsStore.hasEasyContactTicketingSettingsChanged ||
                            communicationSettingsStore.hasEasyContactTicketingValidationErrors
                        }
                    />
                    <UI.Button
                        label={t("labels.discard")}
                        disabled={!communicationSettingsStore.hasEasyContactTicketingSettingsChanged}
                        onClick={onDiscard}
                        className={"ml-2"}
                        variant="outline-primary"
                    />
                </UI.Col>
            </UI.Row>
        </React.Fragment>
    );
};

export const EasyContactTicketingCommunicationSettings = withRouter(
    Sentry.withProfiler(observer(EasyContactTicketingCommunicationSettingsBase))
);
